angular.module('app.components')
  .directive('cellBar', () => ({
    restrict: 'E',
    replace: true,
    scope: {
      value: '@',
      color: '@',
    },
    controller: ['$scope',
      $scope => {
        $scope.progress = isNaN($scope.value) ?
          'width:0' : `width:${$scope.value}%`;
      }],
    template: `
      <div class="bar-wrap">
        <span class="bar u-nomargin {{color}}">
          <span style="{{progress}}"></span>
        </span>
      </div>`,
  }));
